import { Box, Typography, useTheme } from "@mui/material";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useState, useEffect } from "react";
import { CheckCircle, Cancel, QuestionMark } from "@mui/icons-material";
import { tokens } from "../../theme";


const SorteiosList = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const { data, selectAll, checked, setChecked, firstRender, setFirstRender } = props;
    

    // Handle change for specific checkbox
    const handleChange = (id) => (event) => {
        setChecked((prev) => ({
            ...prev,
            [id]: event.target.checked,
        }));
    };


    useEffect(() => {
        if (data.length > 0) {
            // Set default checked state when data is loaded
            const initialCheckedState = data?.reduce((acc, item) => {
                if (Number(item.total_value_sold) > 0 && item.is_paid === true) {
                    acc[item.id] = true; // Default all to true
                }
                return acc;
            }, {});

            setChecked(initialCheckedState);
            setFirstRender(false)
        }
    }, [data]);

    useEffect(() => {
        // Set default checked state when data is loaded
        if (!firstRender) {
            const initialCheckedState = data.reduce((acc, item) => {
                acc[item.id] = selectAll ? true : false; // Default all to true
                return acc;
            }, {});
            setChecked(initialCheckedState);
        }
    }, [selectAll]); // Runs when `data` changes




    const formatNumber = number => {
        return number?.toLocaleString("pt-br", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })
    }
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("pt-BR"); // Format as DD/MM/YYYY
    }


    const formatTable = {
        display: 'grid',
        gridTemplateColumns: '80px 300px repeat(4, 200px)',
        // gridTemplateColumns: "repeat(auto-fill, 80px 300px)",
        gap: '20px',
        alignItems: 'center',
        paddingLeft: '10px'
    }
    return (
        <Box sx={{
            width: '100%',
            backgroundColor: colors.pink[600],
            padding: '10px',
            marginTop: '20px',
            borderRadius: '8px',
            overflow: 'hidden',
            minWidth: '1200px'
        }}

        >
            <Box
                sx={{
                    ...formatTable,
                    paddingBottom: '5px'
                }}
            >
                <Typography fontWeight={"bold"}>Gerar</Typography>
                <Typography fontWeight={"bold"}>Nome</Typography>
                <Typography fontWeight={"bold"}>Data Acerto</Typography>
                <Typography fontWeight={"bold"}>Pago</Typography>
                <Typography fontWeight={"bold"}>Valor</Typography>
                <Typography fontWeight={"bold"}>Cupons</Typography>
            </Box>
            {
                data.sort((a, b) => a.seller.nome.localeCompare(b.seller.nome)).map((data, index) => {
                    const ticketNumbers = Math.floor(data.total_value_sold / 250)
                    return (
                        <Box key={index}
                            sx={{
                                ...formatTable,
                                backgroundColor: index % 2 === 0 && colors.pink[700],
                                color: checked[data.id] && colors.greenAccent[500],
                                fontWeight: checked[data.id] && 'bold',
                                opacity: !checked[data.id] && 0.5
                                // backgroundColor: checked[data.id] && colors.greenAccent[100],
                            }}>
                            <FormControlLabel
                                control={<Checkbox checked={checked[data.id] || false}
                                    color="secondary" onChange={handleChange(data.id)}
                                />}
                            />
                            <Typography>{data.seller.nome}</Typography>
                            <Typography>{formatDate(data.pay_date)}</Typography>
                            <Typography>{!data.is_paid ? <Cancel color="error" /> : <CheckCircle color="success" />}</Typography>
                            {/* <Typography><QuestionMark /></Typography> */}
                            <Typography>R$ {formatNumber(Number(data.total_value_sold))}</Typography>
                            <Typography>{ticketNumbers}</Typography>
                        </Box>
                    )
                })
            }
        </Box>
    );
}

export default SorteiosList;